import React from "react";
import CustomModal from "../../../components/Modal/CustomModal";
import CustomSearch from "../../../components/SearchSimples/CustomSearch";
import NotInformation from "../../../components/NotInformation";
import ResidentAssignedCard from "./Residents/ResidentAssignedCard";
import VerifiedUnverifiedUsersModalApp from "../Functionality/VerifiedUnverifiedUsersModalApp";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Read-only list of the users of the building that share the verification status
 * of the resume card that opened it, rendered as the same resident card grid used
 * by the residents tabs.
 *
 * @param {boolean} props.show - Modal visibility.
 * @param {Function} props.onHide - Closes the modal.
 * @param {string} props.buildingId - Building the residents belong to.
 * @param {Object} props.userClassificationSelected - Classification card that opened the modal.
 */
const VerifiedUnverifiedUsersModal = ({ show, onHide, buildingId, userClassificationSelected }) => {
    const {
        t, // Translation function
        searchElement,
        setSearchElement,
        results,
        handleSearch,
        handleResetSearch,
        pagination
    } = VerifiedUnverifiedUsersModalApp({
        buildingId,
        userClassificationSelected
    });

    return (
        <CustomModal
            show={show}
            title={t(userClassificationSelected?.titleTrans)}
            size='lg' // Modal size (large)
            buttonConfirm='confirm' // Text on the confirm button
            cancelButton={false} // Show cancel button
            confirmButton={false}
            onHide={() => {
                onHide();
            }}
            onConfirm={() => {
                onHide()
            }} // Function to call when the confirm button is clicked
            classNameBody="pt-2"
        >
            <div className="row mb-4">
                <div className={"col-12 px-0"}>
                    <CustomSearch
                        id={"txt_vuum_search_simple"}
                        label={'search_by_name_email_or_apartment'}
                        value={searchElement}
                        setValue={setSearchElement}
                        onChange={(e) => setSearchElement(e.target.value)}
                        searchFunction={handleSearch}
                        onReset={handleResetSearch}
                    />
                </div>
            </div>

            { results?.content?.length > 0 ? (
                <>
                    <div className={"row"}>
                        {
                            results?.content?.map((user) => (
                                <div className='col-12 col-md-6 mb-3 px-1' key={user?.userId}>
                                    <ResidentAssignedCard
                                        keyId={'userId'}
                                        item={user}
                                    />
                                </div>
                            ))
                        }
                    </div>

                    {pagination()}
                </>
            ) : (
                <NotInformation
                    text={searchElement === "" ? t('no_records_available') : t("no_results_found")}
                    card={true}
                />
            )}
        </CustomModal>
    );
};

export default VerifiedUnverifiedUsersModal;
